angular.module('GatorPad.controllers.SavedData', [])

  .controller('SavedDataController', ['$rootScope', '$scope', 'ApiService', '_', '$q', 'moment', function ($rootScope, $scope, ApiService, _, $q, moment) {

  $scope.loadFromStorage = function () {
    $scope.inventoryData = [];
    $scope.feedData = [];
    for (var i = 0; i < window.localStorage.length; i++) {
      var key = window.localStorage.key(i);

      if (key.indexOf("INVENTORY") >= 0) {
        var jsonData = JSON.parse(window.localStorage.getItem(key));
        jsonData.storageKey = key;
        jsonData.selected = false;
        $scope.inventoryData.push(jsonData);
      }

      if (key.indexOf("FEED") >= 0) {
        var jsonData = JSON.parse(window.localStorage.getItem(key));
        jsonData.storageKey = key;
        jsonData.selected = false;
        $scope.feedData.push(jsonData);
      }
    }

    $scope.inventoryData.sort(function(a, b) {
      var aDate = moment(a.entryDate);
      var bDate = moment(b.entryDate);
      
      if (aDate.isBefore(bDate)) return -1;
      if (aDate.isAfter(bDate)) return 1;
      return 0;
    });
    
    $scope.feedData.sort(function(a, b) {
      var aDate = moment(a.entryDate);
      var bDate = moment(b.entryDate);
      
      if (aDate.isBefore(bDate)) return -1;
      if (aDate.isAfter(bDate)) return 1;
      return 0;
    });
  };

  $scope.anyInventorySelected = function () {
    return (_.findWhere($scope.inventoryData, { selected: true }) || _.findWhere($scope.inventoryData, { selected: true }));
  };

  $scope.anyFeedSelected = function () {
    return (_.findWhere($scope.feedData, { selected: true }) || _.findWhere($scope.feedData, { selected: true }));
  };

  $scope.clearAll = function () {
    window.localStorage.clear();
  };

  $scope.clearInventory = function () {
    angular.forEach($scope.inventoryData, function (tank) {
      if (tank.selected) {
        window.localStorage.removeItem(tank.storageKey);
      }
    });

    angular.forEach($scope.feedData, function (tank) {
      if (tank.selected) {
        window.localStorage.removeItem(tank.storageKey);
      }
    });

    $scope.loadFromStorage();
  };

  $scope.clearFeed = function () {
    angular.forEach($scope.feedData, function (tank) {
      if (tank.selected) {
        window.localStorage.removeItem(tank.storageKey);
      }
    });

    $scope.loadFromStorage();
  };

  $scope.uploadInventoryData = function () {
    var inventorySubmission = [];

    angular.forEach($scope.inventoryData, function (tank) {
      if (tank.selected) {
        inventorySubmission.push({ submissionId: tank.storageKey, entryDate: tank.entryDate, barnId: tank.barnId, tankId: tank.tankId, dead: tank.dead, harvest: tank.harvest, transfer_in: tank.transfer_in, transfer_out: tank.transfer_out });
      }
    });

    ApiService.uploadInventory(inventorySubmission)
      .then(function (result) {
        
      angular.forEach(result.succeeded, function (subRecord) {
        window.localStorage.removeItem(subRecord.submissionId);
      });

      angular.forEach(result.failed, function (subRecord) {
        var r = JSON.parse(window.localStorage.getItem(subRecord.submissionId));
        r.duplicateEntry = true;
        window.localStorage.setItem(subRecord.submissionId, JSON.stringify(r));
      });

      $scope.loadFromStorage();

      ApiService.resetLocalStorage(false);
      ApiService.getFarmsOnline()
        .then(function (farmList) {
        var tankQs = [];
        angular.forEach(farmList, function (farm) {
          angular.forEach(farm.barns, function (barn) {
            tankQs.push(ApiService.getTanksOnline(barn.id));
          });
        });

        $q.all(tankQs).then(function () { }, function (result) { });

      }, function (result) { });

      $scope.saveModalTitle = "Data upload";
      if (result.failed.length > 0) {
        $scope.saveModalBody = "Some inventory data could not be uploaded to the Gator system.";
      } else {
        $scope.saveModalBody = "The selected inventory data has been uploaded to the Gator system.";
      }
      $rootScope.Ui.turnOn('modalSave');
    }, function (result) {
        $scope.saveModalTitle = "Data upload";
        $scope.saveModalBody = "An error was encountered uploading inventory data to the Gator system: " + result;
        $rootScope.Ui.turnOn('modalSave');
      });
  };

  $scope.uploadFeedData = function () {
    var feedSubmission = [];

    angular.forEach($scope.feedData, function (tank) {
      if (tank.selected) {
        feedSubmission.push({ submissionId: tank.storageKey, entryDate: tank.entryDate, barnId: tank.barnId, tankId: tank.tankId, feedType: tank.feedType, physicalTankCount:tank.physicalTankCount, quantity: tank.feedQuantity });
      }
    });

    ApiService.uploadFeed(feedSubmission)
      .then(function (result) {
        
      angular.forEach(result.succeeded, function (subRecord) {
        window.localStorage.removeItem(subRecord.submissionId);
      });

      angular.forEach(result.failed, function (subRecord) {
        var r = JSON.parse(window.localStorage.getItem(subRecord.submissionId));
        r.duplicateEntry = true;
        window.localStorage.setItem(subRecord.submissionId, JSON.stringify(r));
      });

      $scope.loadFromStorage();

      ApiService.resetLocalStorage(false);
      ApiService.getFarmsOnline()
        .then(function (farmList) {
        var tankQs = [];
        angular.forEach(farmList, function (farm) {
          angular.forEach(farm.barns, function (barn) {
            tankQs.push(ApiService.getTanksOnline(barn.id));
          });
        });

        $q.all(tankQs).then(function () { }, function (result) { });

      }, function (result) { });

      $scope.saveModalTitle = "Data upload";
      if (result.failed.length > 0) {
        $scope.saveModalBody = "Some feed data could not be uploaded to the Gator system.";
      } else {
        $scope.saveModalBody = "The selected feed data has been uploaded to the Gator system.";
      }
      $rootScope.Ui.turnOn('modalSave');
    }, function (result) {
        $scope.saveModalTitle = "Data upload";
        $scope.saveModalBody = "An error was encountered uploading feed data to the Gator system: " + result;
        $rootScope.Ui.turnOn('modalSave');
      });
  };
  
  $scope.loadFromStorage();
}]);
